<template>
  <div id="app">
    <MaintenanceBanner />
    <Navbar />

    <div id="main-content" ref="main-content" class="container-fluid">
      <div class="row">
        <div class="col-12">
          <router-view />
        </div>

        <div
          v-if="$route.meta.navigationAvailable"
          class="mobile-back-button d-block d-lg-none"
        >
          <a class @click="$router.go(-1)">
            <button
              class="btn btn-primary d-flex align-items-center justify-content-center"
            >
              <i class="material-icons">arrow_back</i>
            </button>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./components/Navbar/Navbar";
import MaintenanceBanner from "./components/MaintenanceBanner";
import "./assets/css/shared.css";

export default {
  name: "App",
  components: {
    Navbar,
    MaintenanceBanner,
  },
  beforeMount() {
    window.setDeviceInfo = this.setDeviceInfo;
    this.setIsOnNative();
  },
  data: function() {
    return {
      favouritedScenariosKey: 0,
      searchTerm: "",
    };
  },
  methods: {
    setDeviceInfo(device_id, product, appVersion = null, supportedLicenseVersion = undefined) {
      let deviceInfo = {
        device_id: device_id,
        product: product,
        app_version: appVersion,
        supported_license_version: supportedLicenseVersion,
      };
      this.$store.commit("setDeviceInfo", deviceInfo);
    },
    setIsOnNative() {
      let isOnNative = window.webkit != null;
      this.$store.commit("setIsOnNative", isOnNative);
      if (this.$store.state.isOnNative) {
        window.webkit.messageHandlers.getDeviceInfo.postMessage("request");
      }
    },
    updateFavouriteScenariosList() {
      this.favouritedScenariosKey += 1;
    },
  },
};
</script>

<style>
[v-cloak] {
  display: none;
}

body {
  background: var(--light);
}

#app {
  font-family: "Roboto", Helvetica, Arial, sans-serif;
  background: var(--light);
}

.list-group-item {
  background: var(--light);
}

@media (max-width: 992px) {
  #app {
    margin-bottom: 100px;
  }
}

h2,
h3,
h4,
h5 {
  color: #014a8f;
  font-weight: 500;
  font-family: "Roboto", sans-serif;
}
h2,
h3 {
  font-weight: 600;
}

.favourite-scenarios {
  padding: 0;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .reverse-mobile {
    flex-direction: column-reverse;
  }
}
@media (max-width: 992px) {
  .reverse-mobile {
    flex-direction: column-reverse;
  }
}
@media (min-width: 992px) {
  .reverse-mobile {
    flex-direction: row;
  }
}

.slide-fade-enter-active {
  transition: all 0.1s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(0, 10, 0, 0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(35px);
  opacity: 0;
}

.fast-fade-enter-active {
  transition: all 0.1s ease;
}
.fast-fade-leave-active {
  transition: all 0.1s cubic-bezier(0, 10, 0, 0);
}
.fast-fade-enter, .fast-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(40px);
  opacity: 0;
}

.mobile-back-button {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 0px 15px 15px 0px;
}

.mobile-back-button {
  box-shadow: 0px 17px 10px -10px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all ease-in-out 300ms;
}

.mobile-back-button i {
  padding: 7px;
  font-size: 30px;
}

.mobile-back-button:hover {
  box-shadow: 0px 37px 20px -15px rgba(0, 0, 0, 0.2);
  transform: translate(0px, -10px);
}

.mobile-scenarios-button {
  position: fixed;
  bottom: 0;
  right: left;
  margin: 0px 0px 15px 15px;
}

.mobile-scenarios-button {
  box-shadow: 0px 17px 10px -10px rgba(0, 0, 0, 0.4);
  cursor: pointer;
  transition: all ease-in-out 300ms;
}

.mobile-scenarios-button i {
  padding: 7px;
  font-size: 30px;
}

.mobile-scenarios-button:hover {
  box-shadow: 0px 37px 20px -15px rgba(0, 0, 0, 0.2);
  transform: translate(0px, -10px);
}

#app {
  min-height: 100vh;
}

.btn-success {
  background: #ff9817;
  border-color: #ff9817;
}

.btn-success:hover {
  background: #ec7712;
  border-color: #ec7712;
}

.btn-success:active,
.btn-success:focus {
  background: #ff7600 !important;
  border-color: #ff7600 !important;
  outline: #ff7600 !important;
  box-shadow: #ff7600 !important;
}

.router-link-active.btn.btn-primary {
  background-color: #478ac1;
}

.favourite-icon {
  font-size: 20px;
  color: var(--isim-light-text);
}
</style>
